import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Button, Card, Grid, Stack, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { HeaderLayout } from "../../components";

interface IProps {
  children?: React.ReactNode;
  faded?: boolean;
  actions?: React.ReactNode;
  sideBarContent?: React.ReactNode;
}

const DetailPageLayout = (props: IProps) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <HeaderLayout
      title={
        <Stack direction="row" justifyContent="space-between">
          <Button
            variant="tertiary"
            startIcon={<ArrowBackIosNewRoundedIcon fontSize="large" />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          {props.actions}
        </Stack>
      }
    >
      <Grid container spacing={1} sx={{ justifyContent: "center" }}>
        <Grid size={{ sm: 12, md: 8 }} sx={{ width: "100%" }}>
          <Card sx={{ background: props.faded ? theme.palette.grey[100] : undefined }}>{props.children}</Card>
        </Grid>
        {props.sideBarContent && !props.faded && <Grid size={{ xs: 12, md: 4 }}>{props.sideBarContent}</Grid>}
      </Grid>
    </HeaderLayout>
  );
};

export { DetailPageLayout };
